export namespace InstallationDetailsHeaderHelper {
  export enum ImagePath {
    wallboxDefaultImagePath = 'assets/icons/wallbox/wallbox-e3.svg',
    wallbox3rdPartImagePath = 'assets/icons/wallbox/wallbox-3rd-party.svg',
  }
}
